import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux'
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import {currency} from '../../redux/actions/filterActions';
import { makeStyles } from '@material-ui/core/styles';
import arrowDown from '../../assets/arrowdown.SVG';
import { isMobile } from "react-device-detect";

const useStyles = makeStyles({
    selectBorder: {
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: '#fff'
        },
      },
      imageIcon:{
        position: 'absolute',
        marginLeft: isMobile ? 298 : 275,
        pointerEvents: 'none',
    }
});

const ArrowIcon = () =>{
  const classes = useStyles();

  return(
      <img className={classes.imageIcon} src={arrowDown}/>
  );
}

const Currency = ({currency }) => {
    const classes = useStyles();
    const [state, setState] = useState('RUB');

    useEffect(() => {
      if (localStorage.getItem('currency')) {
          setState(localStorage.getItem('currency'));
          currency(localStorage.getItem('currency'));
      }
  }, []);

    const handleChange = (event) => {
        setState(event.target.value);
        currency(event.target.value);
        localStorage.setItem('currency', event.target.value);
    };


    return (
        <FormControl variant="outlined" >
                <InputLabel shrink={true} classes={{ root: classes.label }}>Валюта</InputLabel>
                <Select
                    className={classes.selectBorder}
                    value={state}
                    onChange={handleChange}
                    IconComponent = {ArrowIcon}
                    label="Направление"
                    variant="outlined"
                    MenuProps={{
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "left"
                        },
                        transformOrigin: {
                          vertical: "top",
                          horizontal: "left"
                        },
                        getContentAnchorEl: null
                      }}
                >
                    <MenuItem  value={'RUB'}>RUB</MenuItem>
                    <MenuItem  value={'USD'}>USD</MenuItem>
                    <MenuItem  value={'EUR'}>EUR</MenuItem>
                </Select>
            </FormControl>
    );
}

const mapStateToProps = state => ({
    currency: state.currency,
})

export default connect(mapStateToProps, { currency, })(Currency)